import { FC } from 'react'
import {
  AutocompleteInput, BooleanInput, Create, ReferenceInput, SelectInput, SimpleForm,
  TextInput, required, useGetOne,
} from 'react-admin'
import { useWatch } from 'react-hook-form'
import { useLocation } from 'react-router-dom'
import { LOG_LEVEL_CHOICES, SaveOnlyToolbar, EnvironmentSelector } from '../../components'
import { McpServerOut } from '../../types/apiRequests'

const McpEnvironmentSelector: FC = () => {
  const serverId = useWatch({ name: 'server_id' }) as string | undefined

  const { data: server } = useGetOne<McpServerOut>(
    'mcp_server',
    { id: serverId ?? '' },
    { enabled: !!serverId },
  )

  if (!serverId) return null

  return <EnvironmentSelector applicationId={server?.application_id} urlField="base_url" />
}

const OrganizationMcpLinkCreate: FC = () => {
  const location = useLocation()
  const hasPrefill = !!(location.state as Record<string, unknown> | undefined)?.record

  return (
    <Create redirect="edit">
      <SimpleForm
        defaultValues={{ enabled: true }}
        toolbar={hasPrefill ? <SaveOnlyToolbar alwaysEnable /> : undefined}
      >
        {/* eslint-disable-next-line camelcase */}
        <ReferenceInput source="organization_id" reference="organization">
          <AutocompleteInput
            optionText="display_name"
            label="data.organization"
            fullWidth
            validate={required()}
          />
        </ReferenceInput>
        {/* eslint-disable-next-line camelcase */}
        <ReferenceInput source="server_id" reference="mcp_server">
          <SelectInput optionText="display_name" label="data.mcpServer" fullWidth validate={required()} />
        </ReferenceInput>
        <McpEnvironmentSelector />
        <TextInput source="base_url" label="data.baseUrl" fullWidth helperText="data.baseUrlHelp" />
        <BooleanInput source="enabled" label="data.enabled" defaultValue={true} />
        <SelectInput
          source="log_level"
          label="data.logLevel"
          choices={LOG_LEVEL_CHOICES}
          defaultValue="normal"
        />
      </SimpleForm>
    </Create>
  )
}

export default OrganizationMcpLinkCreate
